import { Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Navbar from './Navbar';
import './App.css';

const ORGANIZATION_JSON_LD = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'AquaWARE',
    url: 'https://landingpage.aquaware.no',
    logo: 'https://landingpage.aquaware.no/images/bubbleswhite.png',
    description: "AquaWARE is Searas' digital platform for aquaculture: real-time water quality monitoring, predictive analytics, simulators and automated reporting for smarter, more sustainable fish farming.",
    sameAs: [
        'https://no.linkedin.com/company/searas',
    ],
};

const Layout = () => {

    return (
        <>
            <Helmet>
                <script type="application/ld+json">
                    {JSON.stringify(ORGANIZATION_JSON_LD)}
                </script>
            </Helmet>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
                <Navbar />
                <div className="content" style={{ flex: 1 }}>
                    {/* The Outlet renders the current child route's component */}
                    <Outlet />
                </div>
                <footer className='App-footer'> Searas </footer>
            </div>
        </>
    );
};

export default Layout;